import { render, staticRenderFns } from "./messageTemplateDetailContent.vue?vue&type=template&id=2bdb61e0"
import script from "./messageTemplateDetailContent.vue?vue&type=script&lang=js"
export * from "./messageTemplateDetailContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports